interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  light = false,
}: SectionHeadingProps) {
  return (
    <div
      className={`flex flex-col ${
        align === "center" ? "items-center text-center" : "items-start text-left"
      } gap-4`}
    >
      {eyebrow && (
        <span
          className={`text-xs md:text-sm font-semibold uppercase tracking-[0.25em] ${
            light ? "text-primary-300" : "text-primary-600"
          }`}
        >
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-3xl md:text-4xl lg:text-5xl leading-tight ${
          light ? "text-background-50" : "text-foreground-900"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`max-w-2xl text-base md:text-lg leading-relaxed ${
            light ? "text-background-100/80" : "text-foreground-500"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}